import { Seccion } from "./bitacora.model"
import { Origen, Prioridad, TipoTarea } from "./tareas.model"
import { Rol, Usuario } from "./usuarios.model"

export interface FormTareaInterface {
    tipoTarea: number
    nombreGestion: string
    descripcion: string
    usuarioAsignado: number
    prioridad: number
    origen: number
    seccion: number
    solicitante:string
    clasificacion: number
}

export interface Clasificacion {
    tipologiaId: number
    descripcion: string
    valor1: string
    valor2: string
    valor3: string
  }

export class CrearTareaModel {
    nombre: string;
    descripcion: string;
    usuarioAsignado: Usuario;
    seccion: Seccion;
    prioridad: Prioridad;
    origen: Origen;
    tipoTarea: TipoTarea;
    solicitante:string;
    clasificacion: Clasificacion;
  
    constructor(formControl: FormTareaInterface) {
      this.nombre = formControl.nombreGestion;
      this.descripcion = formControl.descripcion;
  
      this.usuarioAsignado = {
        usuarioId: formControl.usuarioAsignado,
        nombreCompleto: '',
        email: '',
        rol: {} as Rol,
        estado: { tipologiaId: 0, descripcion: '', valor1: '', valor2: '', valor3:'' },
        seccion: {} as Seccion,
      };
  
      this.seccion = { tipologiaId: formControl.seccion, descripcion: '', valor1: '', valor2: '', valor3:'' };
      this.prioridad = { tipologiaId: formControl.prioridad, descripcion: '', valor1: '', valor2: '', valor3: '' };
      this.origen = { tipologiaId: formControl.origen, descripcion: '', valor1: '', valor2: '' };
      this.tipoTarea = { tipologiaId: formControl.tipoTarea, descripcion: '', valor1: '', valor2: '' };
      this.solicitante = formControl.solicitante;
      this.clasificacion= { tipologiaId: formControl.clasificacion, descripcion: '', valor1: '', valor2: '', valor3: '' };
    }
  }